import { render } from "./BackClaim.vue?vue&type=template&id=0fbb43fb&scoped=true"
import script from "./BackClaim.vue?vue&type=script&lang=js"
export * from "./BackClaim.vue?vue&type=script&lang=js"

import "./BackClaim.vue?vue&type=style&index=0&id=0fbb43fb&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fbb43fb"]])

export default __exports__